export default __webpack_public_path__ + "static/media/Djeco-Bigabasic-2.54f5504f.jpg";